import script from "./LeadImportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadImportModal.vue?vue&type=script&setup=true&lang=js"

import "./LeadImportModal.vue?vue&type=style&index=0&id=2ff3f9f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff3f9f5"]])

export default __exports__